/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BilletOrderResponseViewModel } from "../types/BilletOrderResponseViewModel.ts";
import { billetInvoiceResponseViewModelSchema } from "./billetInvoiceResponseViewModelSchema.ts";
import { billetOrderAddressResponseViewModelSchema } from "./billetOrderAddressResponseViewModelSchema.ts";
import { billetOrderCustomerResponseViewModelSchema } from "./billetOrderCustomerResponseViewModelSchema.ts";
import { billetOrderItemResponseViewModelSchema } from "./billetOrderItemResponseViewModelSchema.ts";
import { boletoResponseViewModelSchema } from "./boletoResponseViewModelSchema.ts";

export const billetOrderResponseViewModelSchema = z.object({
  id: z.string().nullish(),
  idExternal: z.string().nullish(),
  createdAt: z.optional(z.string().datetime()),
  updatedAt: z.string().datetime().nullish(),
  amountPaid: z.number().nullish(),
  amount: z.optional(z.number()),
  status: z.string().nullish(),
  issueInvoice: z.optional(z.boolean()),
  issueReceipt: z.optional(z.boolean()),
  companyBillingDocument: z.string().nullish(),
  paymentMethod: z.string().nullish(),
  items: z
    .array(z.lazy(() => billetOrderItemResponseViewModelSchema))
    .nullish(),
  billingAddress: z.optional(
    z.lazy(() => billetOrderAddressResponseViewModelSchema),
  ),
  customer: z.optional(
    z.lazy(() => billetOrderCustomerResponseViewModelSchema),
  ),
  boletos: z.array(z.lazy(() => boletoResponseViewModelSchema)).nullish(),
  invoices: z
    .array(z.lazy(() => billetInvoiceResponseViewModelSchema))
    .nullish(),
}) as unknown as ToZod<BilletOrderResponseViewModel>;
